import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import {
  Home,
  Plane,
  BookOpen,
  BarChart3,
  Mail
} from 'lucide-react'
import { cn } from '@/lib/utils'
import { useAuthStore } from '@/store/authStore'

export function Navigation() {
  const { t } = useTranslation()
  const location = useLocation()
  const { user } = useAuthStore()

  const navItems = [
    { path: '/', icon: Home, label: t('navigation.dashboard', 'Dashboard') },
    { path: '/aircraft', icon: Plane, label: t('navigation.aircraft', 'Aircraft') },
    { path: '/journals', icon: BookOpen, label: t('navigation.journals', 'Journals') },
    { path: '/reports', icon: BarChart3, label: t('navigation.reports', 'Reports') },
  ]

  // Add invitations link only for operators
  if (user?.role === 'operator') {
    navItems.push({
      path: '/invitations',
      icon: Mail,
      label: t('navigation.invitations', 'Convites')
    })
  }

  return (
    <nav className="hidden lg:block w-64 bg-white border-r border-slate-200 min-h-screen fixed left-0 top-16 p-4">
      <div className="space-y-2">
        {navItems.map((item) => {
          const Icon = item.icon
          const isActive = location.pathname === item.path ||
            (item.path !== '/' && location.pathname.startsWith(item.path))

          return (
            <Link
              key={item.path}
              to={item.path}
              className={cn(
                'flex items-center gap-3 px-4 py-3 rounded-lg transition-colors',
                isActive
                  ? 'bg-primary-50 text-primary-700 font-medium'
                  : 'text-slate-600 hover:bg-slate-50'
              )}
            >
              <Icon className="w-5 h-5" />
              <span>{item.label}</span>
            </Link>
          )
        })}
      </div>
    </nav>
  )
}
